import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import GlobalThrobberComponent from '../components/global_throbber_component';
import { useNotification } from '../components/global_noification_component';
import '../css/discord_application_page.css';
const API_BASE = process.env.REACT_APP_API_BASE
const API_VERSION = process.env.REACT_APP_API_ENVIRONMENT
const OAUTH_PAGE = process.env.REACT_APP_API_DISCORD_OAUTH_PAGE;
const SITE_ENVIRONMENT = process.env.REACT_APP_SITE_ENVIRONMENT

const DiscordTrueBallerApplicationPage = () => {
  const navigate = useNavigate();
  const notify = useNotification();
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [username, setUsername] = useState('');
  const [agree1, setAgree1] = useState(false);
  const [agree2, setAgree2] = useState(false);
  const [agree3, setAgree3] = useState(false);
  const [meaning, setMeaning] = useState('');
  const [errors, setErrors] = useState({});
  const [user, setUser] = useState(null);
  const [eligible, setEligible] = useState(false);
  const lockedUntilCookie = Number(Cookies.get('tb_application_locked_until') || 0);
  const [lockedUntil, setLockedUntil] = useState(lockedUntilCookie);
  const [blockedTimer, setBlockedTimer] = useState(lockedUntil > Date.now() ? lockedUntil - Date.now() : 0);

  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get('code');
    (async () => {
      let data;
      const stored = sessionStorage.getItem('discordUser');
      if (stored) {
        data = JSON.parse(stored);
      } else if (code) {
        try {
          const res = await fetch(`${API_BASE}/${API_VERSION}/public/oAuth/discord?code=${code}`);
          const result = await res.json();
          if (!res.ok || !result.success) {
            notify('error', result.data?.message || 'Authentication failed');
            window.location.href = OAUTH_PAGE;
            return;
          }
          data = result.data;
          sessionStorage.setItem('discordUser', JSON.stringify(data));
        } catch {
          notify('error', 'Error fetching Discord user info');
          setLoading(false);
          navigate('/');
          return;
        }
      } else {
        if (!Cookies.get('refresh_token')) {
          window.location.href = OAUTH_PAGE;
          return;
        }
      }
      setUser(data);
      try {
        const res2 = await fetch(`${API_BASE}/${API_VERSION}/public/oAuth/discord/fetch`, {
          method: 'POST',
          headers: { 'Content-Type':'application/json' },
          body: JSON.stringify({
            code: Cookies.get('refresh_token'),
            application: 'true_baller',
            environment: SITE_ENVIRONMENT
          })
        });
        const check = await res2.json();
        if (!user) {
          setUser(check.user);
          Cookies.set('discord_id', check.user.id, { sameSite: 'strict' });
          Cookies.set('username', check.user.username, { sameSite: 'strict' });
          Cookies.set('global_name', check.user.global_name, { sameSite: 'strict' });
          Cookies.set('avatar', check.user.avatar, { sameSite: 'strict' });
          Cookies.set('banner', check.user.banner, { sameSite: 'strict' });
          Cookies.set('email', check.user.email, { sameSite: 'strict' });
          Cookies.set('code', check.code, { sameSite: 'strict' });
          Cookies.set('refresh_token', check.refresh_token, { sameSite: 'strict' });
        }
        setEligible(check.is_in_gym_guild && (check.is_moderator || check.has_required_role));
        if (lockedUntil > 0 && blockedTimer < 120000) {
          notify('info', 'Hang tight — you can resubmit in under 2 minutes.');
        }
      } catch {
        notify('error', 'Failed verifying eligibility.');
        setLoading(false);
        navigate('/');
        return;
      } finally {
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (lockedUntil === 0) return;
    const timer = setInterval(() => {
      const diff = lockedUntil - Date.now();
      if (diff <= 0) {
        clearInterval(timer);
        Cookies.remove('tb_application_locked_until');
        setBlockedTimer(0);
      } else {
        setBlockedTimer(diff);
      }
    }, 60000);
    return () => clearInterval(timer);
  }, [lockedUntil]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = {};
    if (!username.trim()) errs.username = 'Please enter your in-game username';
    if (!agree1) errs.agree1 = 'You must agree to rule compliance';
    if (!agree2) errs.agree2 = 'You must agree to role removal policy';
    if (!agree3) errs.agree3 = 'You must agree not to beg for the role';
    if (!meaning.trim()) errs.meaning = 'Please explain what True Baller means to you';
    if (Object.keys(errs).length) {
      setErrors(errs);
      Object.values(errs).forEach(msg => notify('error', msg));
      return;
    }
    setLoading(true);
    setSubmitting(true);
    try {
      const applicationData = {
        username,
        'rule-agreement': agree1 ? 'Yes' : 'No',
        'activity-agreement': agree2 ? 'Yes' : 'No',
        'begging-agreement': agree3 ? 'Yes' : 'No',
        'true-baller-meaning': meaning
      };
      const payload = {
        applicationData,
        discordUser: { userData: user }
      };
      const res = await fetch(`${API_BASE}/${API_VERSION}/public/applications/true-baller`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (res.status === 429) {
        const data = await res.json();
        notify('error', data.message || 'Duplicate submission detected. Please wait before reapplying.');
        const until = Date.now() + 7 * 24 * 60 * 60 * 1000;
        Cookies.set('tb_application_locked_until', String(until), { expires: 7, sameSite: 'strict' });
        setLockedUntil(until);
        setBlockedTimer(7 * 24 * 60 * 60 * 1000);
        setLoading(false);
        setSubmitting(false);
        navigate('/');
        return;
      }
      if (res.ok) {
        notify('success', 'True Baller application submitted successfully!');
        const until = Date.now() + 7 * 24 * 60 * 60 * 1000;
        Cookies.set('tb_application_locked_until', String(until), { expires: 7, sameSite: 'strict' });
        setLockedUntil(until);
        setBlockedTimer(7 * 24 * 60 * 60 * 1000);
        navigate('/');
      } else {
        const text = await res.text();
        notify('error', `Submission failed: ${text}`);
      }
    } catch {
      notify('error', 'Error submitting application');
    } finally {
      setLoading(false);
      setSubmitting(false);
    }
  };

  if (loading || !user) {
    return <GlobalThrobberComponent />;
  }

  if (!eligible) {
    return (
      <div className="application-page true-baller">
        <p>You are not yet eligible to submit this application.</p>
      </div>
    );
  }

  if (blockedTimer > 0) {
    return (
      <div className="application-page true-baller">
        <p>You have recently submitted an application. Please wait {Math.ceil(blockedTimer / 60000)} more minutes before submitting again.</p>
      </div>
    );
  }

  return (
    <div className="application-page true-baller">
      <form className="application-form" onSubmit={handleSubmit}>
        <h1>
          True Baller Application
        </h1>
        <div className="form-group">
          <label htmlFor="username">In-Game Username</label>
          <input id="username" type="text" value={username} onChange={(e) => setUsername(e.target.value)} />
          {errors.username && <div className="error">{errors.username}</div>}
        </div>
        <div className="form-group">
          <label>Do you agree that breaking a rule or loopholing it may result in instant disqualification without notice?</label>
          <div>
            <label className='radio-label'>
              <input type="radio" name="agree1" checked={agree1} onChange={() => setAgree1(true)} /> Yes
            </label>
            <label>
              <input type="radio" name="agree1" checked={!agree1} onChange={() => setAgree1(false)} /> No
            </label>
          </div>
          {errors.agree1 && <div className="error">{errors.agree1}</div>}
        </div>
        <div className="form-group">
          <label>Do you agree that if you do get True Ballers, it can be taken at any time due to lack of activity or behavior?</label>
          <div>
            <label className='radio-label'>
              <input type="radio" name="agree2" checked={agree2} onChange={() => setAgree2(true)} /> Yes
            </label>
            <label>
              <input type="radio" name="agree2" checked={!agree2} onChange={() => setAgree2(false)} /> No
            </label>
          </div>
          {errors.agree2 && <div className="error">{errors.agree2}</div>}
        </div>
        <div className="form-group">
          <label>Do you agree that if you continuously ask or beg for the role, your chance to get it will be lowered extremely?</label>
          <div>
            <label className='radio-label'>
              <input type="radio" name="agree3" checked={agree3} onChange={() => setAgree3(true)} /> Yes
            </label>
            <label>
              <input type="radio" name="agree3" checked={!agree3} onChange={() => setAgree3(false)} /> No
            </label>
          </div>
          {errors.agree3 && <div className="error">{errors.agree3}</div>}
        </div>
        <div className="form-group">
          <label htmlFor="meaning">What does &quot;True Baller&quot; mean to you?</label>
          <textarea id="meaning" value={meaning} onChange={(e) => setMeaning(e.target.value)} rows="4" />
          {errors.meaning && <div className="error">{errors.meaning}</div>}
        </div>
        <button type='submit' className='submit-button' disabled={submitting || loading}>
          Submit Application
        </button>
      </form>
    </div>
  );
};

export default DiscordTrueBallerApplicationPage;
